import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Navbar from '../components/navbar';
import './categoryView.css';
import premier from '../icons/premier.png';

const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [yearsInBusiness, setYearsInBusiness] = useState([]);
  const [message, setMessage] = useState('');
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState('');
  const [sortBy, setSortBy] = useState('relevance');
  const [viewMode, setViewMode] = useState('grid');
  const { category } = useParams();

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/userData`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ token }),
          });
          const data = await response.json();
          if (data.status === 'ok') {
            setUserData(data.data);
          } else {
            setError(data.message);
          }
        } catch (err) {
          setError(err.message);
        }
      }
    };

    const fetchSubcategories = async () => {
      if (!category) return;
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/getSubCategory/${category}`);
        if (res.data.status === 'ok') {
          setSubcategories(res.data.data);
        } else {
          setMessage(res.data.message);
        }
      } catch (err) {
        setMessage('Error: ' + err.message);
      }
    };

    fetchUserData();
    fetchProducts();
    fetchSubcategories();
  }, [category]);

  useEffect(() => {
    fetchProducts();
  }, [priceRange, selectedSubcategories, yearsInBusiness, sortBy]);

  const fetchProducts = async () => {
    if (!category) return;

    const location = JSON.parse(localStorage.getItem('location'));
    const pincode = location?.pincode;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/getProductsByCategory/${category}`, {
        params: {
          minPrice: priceRange[0],
          maxPrice: priceRange[1],
          subcategories: selectedSubcategories.join(','),
          minExperience: yearsInBusiness.length > 0 ? Math.min(...yearsInBusiness) : undefined,
          pincode: pincode || '',
          sortBy: sortBy,
        },
      });

      if (res.data.status === 'ok') {
        setProducts(res.data.data);
      } else {
        setMessage(res.data.message);
        setProducts([]);
      }
    } catch (err) {
      setMessage('Error: ' + err.message);
      setProducts([]);
    }
  };

  const handleSubcategoryFilter = (e) => {
    const value = e.target.value;
    setSelectedSubcategories((prev) =>
      e.target.checked ? [...prev, value] : prev.filter((val) => val !== value)
    );
  };

  const handleYearsFilter = (e) => {
    const value = parseInt(e.target.value);
    setYearsInBusiness((prev) =>
      e.target.checked ? [...prev, value] : prev.filter((val) => val !== value)
    );
  };

  const handleMinChange = (e) => {
    const min = parseInt(e.target.value);
    if (min <= priceRange[1]) {
      setPriceRange([min, priceRange[1]]);
    }
  };

  const handleMaxChange = (e) => {
    const max = parseInt(e.target.value);
    if (max >= priceRange[0]) {
      setPriceRange([priceRange[0], max]);
    }
  };

  const handleEnquiry = async (e) => {
    e.preventDefault();
    if (!userData) {
      localStorage.setItem('redirectAfterLogin', window.location.pathname);
      window.location.href = '/vendor/login';
      return;
    }
    const form = e.target;
    const formData = new FormData(form);
    const enquiryData = {
      productname: formData.get('name'),
      product_id: formData.get('id'),
      productPrice: formData.get('price'),
      vendorId: formData.get('vendorId'),
      UserId: userData._id,
      Username: userData.fname,
      UserNumber: userData.number,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/sendEnquiry`, enquiryData, {
        headers: { 'Content-Type': 'application/json' },
      });
      const data = response.data;
      setMessage(data.status === 'ok' ? 'Enquiry sent successfully!' : data.message);
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  return (
    <div>
      <Navbar />
      
      {/* Breadcrumb */}
      <div className="breadcrumb-section">
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item"><a href="/categories">Categories</a></li>
              <li className="breadcrumb-item active">Category Products</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="category-page-container">
        <div className="category-content-cateFilter">
          
          {/* Left Sidebar - Filters */}
          <div className="filter-sidebar-container">
            <div className="filter-panel">
              <div className="filter-header">
                <h4>Refine Results</h4>
                <button className="clear-filters">Clear All</button>
              </div>

              {/* Subcategories Filter */}
              <div className="filter-section-category">
                <h5 className="filter-title">Categories</h5>
                <div className="filter-options">
                  {subcategories.map((sub, i) => (
                    <label key={i} className="filter-checkbox">
                      <input 
                        type="checkbox" 
                        value={sub._id} 
                        onChange={handleSubcategoryFilter} 
                      />
                      <span className="checkmark"></span>
                      <span className="filter-label">{sub.name}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Price Range Filter */}
              <div className="filter-section-category">
                <h5 className="filter-title">Price Range</h5>
                <div className="price-filter">
                  <div className="price-inputs">
                    <div className="price-input-group">
                      <label>Min Price</label>
                      <select value={priceRange[0]} onChange={handleMinChange} className="price-select">
                        {[0, 1000, 2000, 5000, 10000, 20000, 50000].map((price) => (
                          <option key={price} value={price}>
                            ₹{price === 0 ? '0' : price.toLocaleString()}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="price-input-group">
                      <label>Max Price</label>
                      <select value={priceRange[1]} onChange={handleMaxChange} className="price-select">
                        {[1000, 2000, 5000, 10000, 20000, 50000, 100000].map((price) => (
                          <option key={price} value={price}>
                            ₹{price === 100000 ? '100000+' : price.toLocaleString()}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Years in Business Filter */}
              <div className="filter-section-category">
                <h5 className="filter-title">Years in Business</h5>
                <div className="filter-options">
                  {[1, 3, 5, 10].map((year) => (
                    <label key={year} className="filter-checkbox">
                      <input 
                        type="checkbox" 
                        value={year} 
                        onChange={handleYearsFilter} 
                      />
                      <span className="checkmark"></span>
                      <span className="filter-label">{year}+ Years</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Products */}
          <div className="products-main-content">
            
            {/* Results Header */}
            <div className="results-header">
              <div className="results-info">
                <h3 className="results-title">Products ({products.length})</h3>
                <p className="results-subtitle">Find quality products from verified suppliers</p>
              </div>
              
              <div className="results-controls">
                <div className="sort-controls">
                  <label>Sort by:</label>
                  <select 
                    value={sortBy} 
                    onChange={(e) => setSortBy(e.target.value)}
                    className="sort-select"
                  >
                    <option value="relevance">Relevance</option>
                    <option value="price-low">Price: Low to High</option>
                    <option value="price-high">Price: High to Low</option>
                    <option value="newest">Newest First</option>
                  </select>
                </div>
                
                <div className="view-controls">
                  <button 
                    className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                    onClick={() => setViewMode('grid')}
                  >
                    <i className="fas fa-th"></i>
                  </button>
                  <button 
                    className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                    onClick={() => setViewMode('list')}
                  >
                    <i className="fas fa-list"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Products Grid */}
            <div className={`products-container ${viewMode}`}>
              {products.map((product, index) => (
                <div key={index} className="product-card">
                  <div className="product-image-container">
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${product.image[0].replace('\\', '/')}`}
                      alt={product.name}
                      className="product-image"
                    />
                    <div className="product-badges">
                      <span className="verified-badge">✓ Verified</span>
                    </div>
                  </div>
                  
                  <div className="product-details">
                    <h5 className="product-title">{product.name}</h5>
                    <div className="product-price">
                      <span className="current-price-CateFilter">₹{product.sellingPrice?.toLocaleString()}</span>
                    </div>
                    
                    <div className="supplier-info">
                      {product.vendorId?.businessName && (
                        <p className="supplier-name">{product.vendorId.businessName}</p>
                      )}
                      <img src={premier} alt="Premier Supplier" className="supplier-badge"/>
                    </div>
                    
                    <div className="product-actions">
                      <form onSubmit={handleEnquiry}>
                        <input type="hidden" name="name" value={product.name} />
                        <input type="hidden" name="id" value={product._id} />
                        <input type="hidden" name="price" value={product.sellingPrice} />
                        <input type="hidden" name="vendorId" value={product.vendorId?._id} />
                        
                        <button type="submit" className="enquiry-btn-cateFilter">
                          <i className="fas fa-envelope"></i>
                          Send Inquiry
                        </button>
                      </form>
                      <button className="contact-btn-cateFilter">
                        <i className="fas fa-phone"></i>
                        Contact Supplier
                      </button>
                    </div>
                  </div>
                </div>
              ))}
              
              {products.length === 0 && (
                <div className="no-products">
                  <div className="no-products-content">
                    <i className="fas fa-search"></i>
                    <h4>No products found</h4>
                    <p>Try adjusting your filters or search terms</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllProducts;